export default defineNuxtRouteMiddleware(async (to, from) => {
  const { $auth, $api } = useNuxtApp();
  const registrationPagePath = '/partner-registration';

  if (import.meta.server) {
    // TODO: Redirects user back to the partner-registration page if the form is not submitted.
    // Uncomment once the D2C signup flow is stable to prevent users from getting stuck
    // on the partner-registration page.
    // if (
    //   to.path !== registrationPagePath &&
    //   $auth.checkD2CFlowStatus() === 'started'
    // ) {
    //   return navigateTo(registrationPagePath);
    // }

    if (await $auth.checkStatus(to)) {
      const userInfo = await $api.endPoints.getUserInfo();

      const isRegistered =
        userInfo?.userAttributes?.registered;

      if (to.path !== registrationPagePath && isRegistered === false) {
        return navigateTo(registrationPagePath);
      }

      delete to.query.access_token;
      delete to.query.token;
      delete to.query.refresh_token;
      delete to.query.expires_in;
      delete to.query.code;
      delete to.query.memberId;
      to.query.login_completed = 'true';
      return navigateTo(to);
    }
  }
});
